import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Logger } from '../Logger.service';
import { SrdUser } from '../models/srd-user';
import { DialogOverviewExampleDialog } from '../shared/dialog-overview/dailog-overview-example-dialog.component';
import { forbiddenValidator } from '../shared/forbidden.validator';
import { LoginService } from './login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  [x: string]: any;
  router: Router;
  userSrdUser: SrdUser;
  isValidated: boolean;
  loginForm: FormGroup;
  showDialog: boolean = false;

  constructor(
    private fb: FormBuilder,
    router: Router,
    private loginService: LoginService,
    private logger: Logger,
    private dialog: MatDialog
  ) {
    this.router = router;
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      userEmail: [
        ,
        {
          validators: [Validators.required, Validators.email],
          updateOn: 'change',
        },
      ],
      userPassword: [
        ,
        [Validators.required, Validators.minLength(8), forbiddenValidator()],
      ],
    });
  }

  getEmailErrorMessage() {
    return this.userEmail.hasError('required')
      ? 'You must enter a value'
      : this.userEmail.hasError('email')
      ? 'Email should be of form johndoe@example.com'
      : this.userEmail.hasError('userExists')
      ? 'User already exists!'
      : '';
  }

  getPasswordErrorMessage() {
    return this.userPassword.hasError('required')
      ? 'You must enter a value'
      : this.userPassword.hasError('passwordStrength')
      ? 'Your password must have lower case, upper case and numeric characters with min 8 characters'
      : '';
  }

  get userEmail() {
    return this.loginForm.get('userEmail');
  }
  get userPassword() {
    return this.loginForm.get('userPassword');
  }

  login() {
    this.loginService
      .verifyUser(this.userEmail.value, this.userPassword.value)
      .subscribe(
        (isValidated) => {
          if (isValidated) {
            console.log('User validated: ' + isValidated);
            this.router.navigateByUrl('/details');
          }
          if (!isValidated) {
            this.message = ' User does not exist! Please Register to Login. ',
              this.openDialog(this.message);
            console.log(
              'User validated: ' + isValidated + '; User does not exist!'
            );
          }
        },
        (error) => {
          this.message = 'Error encountered when logging in the user!',
            this.openDialog(this.message);
          console.error('Error encountered when logging in the user ' + error);
        }
      );
  }

  register() {
    this.router.navigateByUrl('/register');
  }

  onSubmit() {
    // TODO: Use EventEmitter with form value
    console.warn(this.profileForm.value);
  }

  openDialog(msg: string): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {message: msg};
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
    });
  }
}
